<template>
  <div class="javaTemplate">
    <!--<div class="topImgMoudle" v-if='topImgSt'>
        <div class="closeTopImg" @click="closeTopImg()"><img src="./img/close.png" width="30px" alt=""></div>
        <img v-if="topImg" :src="topImg" width="100%" alt="">
    </div> -->
    <DetailsNav></DetailsNav>
    <div class="banner">
        <div class="banerCont" v-if="bannerInfo" :style="{'background-color': bannerInfo.bannerColor, 'background-image': `url(${bannerInfo.bannerBgImg})`}">
            <div class="cont">
                <div class="leftCont">
                    <div class="logo" v-if="bannerInfo.logo && bannerInfo.logo.length > 0"><img :src="bannerInfo.logo[0].url" height="121px" alt=""></div>
                    <div v-else>
                        <div class="title"><div class="colFont">{{bannerInfo.objectName}}</div></div>
                        <div class="subTitle"><div class="colFont">{{bannerInfo.objectSubtitle}}</div></div>    
                    </div>
                    <div class="desc">
                        <banner-desc :data="strToArr(bannerInfo.objectIntroduction)"></banner-desc>
                    </div>
                    <div class="actionCont" >点击体验 <span v-if="acttionInfo.actionImg && acttionInfo.actionImg.length > 0"><span class="action" @click="openActionHandle()" v-if="butImg"> 操作说明</span>  <img @click="openActionHandle()" v-if="butImg" src="./img/hp_icon.png" width="17" alt=""></span> </div>  
                    <div class="platfromList">
                        <div v-for="(item, num) in platformData" :key="num">
                            <div class="platfromPath" v-if="item.subtitle!=='false'" @mouseover="rwmHover(num)" @mouseout="rwmHover(99)" @click="goDetailPage(item.subtitle)">
                                <img v-if="item.icon && item.icon.length > 0" :src="item.icon[0].url" width="20px" alt=""> {{item.title}}
                                <div :class="{rwm:true, showRwm: showRwm == num}" v-if="item.rwm && item.rwm.length > 0">
                                    <img :src="item.rwm[0].url" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rightCont">
                    <div class="subjectflowTitle">
                        <div class="divNav">
                            <span @click="() => {$router.push('/')}" class="spanSubject">首页 / </span>
                            <span @click="() => {$router.push(routerLink)}" class="spanSubject">Web</span>
                            <span class="spanSplit"> / </span>
                            <span class="spanName">{{ bannerInfo.objectName }}</span>
                        </div>
                    </div>
                    <div class="videoBox">
                        <!-- <div class="bg_lt_icon"></div> -->
                        <div class="videoMain">
                            <div class="actLab"><span></span><span></span><span></span></div>
                            <div v-if="videoUrl" class="play"  @click="handleVideo()">
                                <img src="./img/icon_play_real.png" width="45px" height="45px" alt="">
                                <div class="videoDesc">
                                    了解项目特色
                                    <!-- {{bannerInfo.videoDesc}} -->
                                </div>
                            </div>
                            <img v-if="bannerInfo.videoBackground && bannerInfo.videoBackground.length > 0" width="574" :src="bannerInfo.videoBackground[0].url" alt="">
                        </div>
                        <!-- <div class="bg_rit_icon"></div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="rowBox" v-if="bannerLabItems && bannerLabItems.length > 0">
        <div class="bannerLabItems">
            <div class="labItems" v-for="(item, index) in bannerLabItems" :key="index">
                <div><img v-if="item.icon && item.icon.length" :src="item.icon[0].url" width="20" alt=""></div>
                <div>{{item.lab}}</div>
                <div class="num" v-if="item.num">{{item.num}}</div>
            </div>
        </div>
    </div>
    <div class="platform" v-if="platformInfo && platformData && platIsOpen" :style="{'background-color':platformInfo.platColor, 'background-image':`url(${platformInfo.playBgImg && platformInfo.playBgImg.length > 0  ? platformInfo.playBgImg[0].url : ''})`}">
        <modelTitl v-if="platformInfo" :title="platformInfo.platTitle" :subTitle="platformInfo.platSubTitle" :enTag="String(platformInfo.platEnTitle).toUpperCase()"></modelTitl>
        <Platform :platformData="platformData"></Platform>
    </div>
    <!-- 功能架构 - start -->
    <div class="modelFeatures" id="scrollA"  v-if="modelData">
        <div class="modelCont" v-for="(item, index) in modelData" :key="index+999" :style="{'background-color':item.bgColor, 'background-image':`url(${item.bgImg.length > 0  ? item.bgImg[0].url : ''})`}">
            <div class="modelItem"  :class="{scrollAShow:scrollAShow && index == 0, scrollA1Show:scrollA1Show && index == 1}">
                <modelTitl :title="item.title" :subTitle="item.subTitle" :enTag="String(item.url).toUpperCase()"></modelTitl>
                <div class="bigImgCont">
                    <img :src="item.file && item.file[0].url" width="100%" alt="">
                </div>
            </div>
        </div>
    </div>
    <!-- 功能架构 - end -->
    <!-- 技术优势 - start    -->
    <div class="modelSkill" id="scrollX"  v-if="skillInfo" >
        <div class="showDetails" :class="{scrollXShow:scrollXShow}">
        <modelTitl :title="skillInfo.title" :subTitle="skillInfo.subTitle" :enTag="String(skillInfo.enTitle).toUpperCase()"></modelTitl>
            <div :class="{modelCont:true, modelImg:item.image && item.image.length}" v-for="(item, index) in skillModular" :key="index+999">
                <div class="modelItem" v-if="item.image && item.image.length > 0">
                    <div class="title">{{item.title}}</div>
                    <div class="bigImgCont">
                        <img :src="item.image[0].url" width="100%" alt="">
                    </div>
                </div>
                <div class="textCont"  v-else :style="{'background-color':item.color}">
                    <div class="title">{{item.title}}</div>
                    <img class="icon" :src="item.icon[0].url" width="118px" alt="">
                    <div class="cont">
                        <div class="list" v-for="(it, ind) in item.content" :key="ind+9999">
                        <div class="tit">{{it.title}}</div> 
                        <div class="desc">{{it.desc}}</div>
                        </div>
                    </div>
                </div>
                <div></div>
            </div>
        </div>
    </div>
    <!-- 技术优势 - end    -->
    <!-- 解决方案 -start -->
    <div class="program" id="scrollB"   v-if="programData" :style="{'background-color':programData.BgColor, 'background-image':`url(${programData.bgImg.length > 0  ? programData.bgImg[0].url : ''})`}">
        <div class="programCont" :class="{scrollBShow:scrollBShow}">
            <modelTitl :title="programData.title" :subTitle="programData.subTitle" :enTag="String(programData.desc).toUpperCase()"></modelTitl>
            <div class="continer">
                <div class="cont" >
                    <!-- <div @mouseover="stopScroll()" @mouseout="setScroll()"></div> -->
                    <div class="labCont" >
                        <div :class="{lab:true, act:programState == index}" v-for="(item, index) in programData.AboutImage" @mouseover="checkHandle(index)" :key="index+99">{{item.title}}</div>
                    </div>
                    <div class="scrollCont">
                        <div class="scrollList" :style="programCroll">
                            <div :class="{contInfo:true, showst: programState == index}" v-for="(item, index) in programData.AboutImage" :key="index+8">
                                <div class="textInfo">
                                    <div v-for="(it, ind) in strToArr(item.about)" :key="String(index) + ind">
                                        <div class="tit">{{it.title}}</div>
                                        <div class="desc" v-for="(val, num) in it.content" :key="String(index) + String(ind) + num">
                                            <div v-if="val && val != '' && val.search('-') != -1" style="word-wrap:break-word;white-space:pre-wrap"> 
                                                <span class="destit">{{val.split('-')[0]}}：</span>
                                                <span>{{val.split('-')[1]}}</span>
                                            </div>
                                            <div v-else style="word-wrap:break-word;white-space:pre-wrap">{{val.replace('-', '：')}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="bigImg">
                                    <img :src="item.image[0].url" width="633" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 解决方案 - end -->
    <!-- 课程大纲 - start -->
    <div class="classList" id="scrollC" >
        <div class="scrollCont" :class="{scrollCShow:scrollCShow}">
            <modelTitl v-if="classInfo" :title="classInfo.classTitle" subTitle="" :enTag="classInfo.classEnTitle"></modelTitl>
            <study-path-widge :data="classData"  ></study-path-widge>
        </div>
    </div>
    <!-- 课程大纲 - end -->
    <!-- 适用人群 - start -->
    <div class="suitPersonCont" id="scrollC1"  v-if="suitPersonData" :style="{'background-color':suitPersonData.bgColor}">
        <div class="scrollCont" :class="{scrollC1Show:scrollC1Show}">
            <modelTitl :title="suitPersonData.title" :subTitle="suitPersonData.subTitle" :enTag="suitPersonData.enTitle"></modelTitl>
            <div class="suitItemsCont">
                <div class="suitItems" v-for="(item, index) in suitPersonData.listData" :key="index">
                    <div><img v-if="item.icon && item.icon.length > 0" :src="item.icon[0].url" width="106px" alt=""></div>
                    <div class="desc"> <p v-for="(it, ind) in item.lab.split('|')" :key="ind">{{it}}</p></div>
                </div>
            </div>
        </div>
    </div>
    <!-- 适用人群 - end -->
    <!-- 讲师风采 - start -->
    <div class="teacherCont" id="scrollD"  v-if="teacherInfo && teacherList" :style="{'background-color':teacherInfo.teachBgColor, 'background-image':`url(${teacherInfo.teachBgImg && teacherInfo.teachBgImg.length > 0  ? teacherInfo.teachBgImg[0].url : ''})`}">
        <div class="scrollCont" :class="{scrollDShow:scrollDShow}">
            <modelTitl :title="teacherInfo.teachModleTitle" subTitle="" :enTag="teacherInfo.TeachEnTitle"></modelTitl>
            <common-techer-display-widge :imgs="teacherList" v-if="teacherList.length>0"></common-techer-display-widge> 
        </div>
    </div>
    <!-- 讲师风采 - end -->
    <img v-if="butImg" :src="butImg" width="100%" alt="">
    <bottom-widge></bottom-widge>
    <MenuAdd ref="editMenu"></MenuAdd>
    <div class="javaTemMask" v-show="showActionPop && acttionInfo" >
        <div class="javaTemPop">
            <!-- <div class="title">{{acttionInfo.actionlabel}}</div> -->
            <div class="close" @click="() => showActionPop = false">x</div>
            <div class="infoImg">
                <!-- <img v-if="acttionInfo.actionImg && acttionInfo.actionImg.length > 0" :src="acttionInfo.actionImg[0].url" width="100%" alt=""> -->
                <div class="desc">探索更多功能，请体验项目！</div>
                <div class="goInfo" @click="() => showActionPop = false">
                    <span>开始体验</span>
                </div>
            </div>
        </div>
    </div>
    <RiskWarning ref="RiskWarning" :url="goUrl"></RiskWarning>
  </div>
</template>
<script>
import { webObject } from "../../../../gqlapi/webDetail.js";
import DetailsNav from "./../../../components/detailsNav.vue";
import bannerDesc from "./../../../components/bannerDesc.vue";
import Platform from "./components/Platform.vue"
import studyPathWidge from "./components/javaStudyPathWidge";
import commonTecherDisplayWidge from "./components/techerDisplayWidge";
import modelTitl from "./components/modelTitle.vue"
import bottomWidge from "./../../../components/bottomWidge";
import MenuAdd from "./../../../components/video";
import RiskWarning from "../../../components/riskWarning.vue";
export default {
  components: {
    bannerDesc,
    DetailsNav,
    bottomWidge,
    Platform,
    modelTitl,
    studyPathWidge,
    commonTecherDisplayWidge,
    MenuAdd,
    RiskWarning
  },
  data() {
    return {
        topImg: '',
        butImg: '',
        showRwm: 99,
        bannerDeSt:false,
        showActionPop:false,
        platIsOpen: true,
        baseData:null,
        bannerInfo: null,
        platformInfo: null,
        platformData: null,
        modelData: [],  // 功能模块、技术架构
        programData: null,  // 解决方案
        classData: null, // 课程大纲
        teacherInfo: null,
        teacherList:null, //讲师列表
        classInfo:null,
        programState: 0,
        scrollState: 'add',
        videoUrl: '',
        acttionInfo: null,
        topImgSt: true,
        objName: '',
        routerLink: '',
        scrollAShow: false,
        scrollA1Show: false,
        scrollBShow: false,
        scrollCShow: false,
        scrollC1Show: false,
        scrollDShow: false,
        scrollXShow:false,
        bannerLabItems:[],
        suitPersonData: null,
        skillInfo:null,
        skillModular:[],
        goUrl: ''
    };
  },
  computed: {
      programCroll:function(){
          return {
              width: this.programData.AboutImage.length * 1180 + 'px',
              left: -this.programState * 1180 + 'px'
          }
      }
  },
  created() {
    this.getData();
    window.addEventListener("scroll", this.scrollMoveHandle);
    const st = window.localStorage.getItem('topImgSt')
    if (st == undefined || st == null || st == 'show') {
        window.localStorage.setItem('topImgSt', 'show')
        this.topImgSt = true
    } else {
        this.topImgSt = false
    }
    this.objName = '品达物流'
    this.routerLink = '/web'
  },
  methods: {
      getData() {
        this.$axios.post('/api',{
            operationName: "webObject",
            variables:{
              id: sessionStorage.getItem("detailsId"),
            },
            query: webObject
        })
        .then((res) => {
          const data = this.baseData = res.data.data.webObject
          this.bannerInfo = {
              logo:data.logo,
              objectName:data.objectName,
              objectSubtitle:data.objectSubtitle,
              objectIntroduction:data.objectIntroduction,
              bannerColor:data.bannerColor,
              videoBackground:data.videoBackground,
              videoDesc:data.videoDesc,
              bannerBgImg: data.bannerImg && data.bannerImg.length > 0 ? data.bannerImg[0].url : ''
          }
          this.suitPersonData = {
              title: data.suitPersonTitle,
              subTitle: data.suitPersonSubTitle,
              enTitle: data.suitPersonEnTitle,
              bgColor: data.suitPersonBgColor,
              listData: data.suitPersonItems
          }
          this.bannerLabItems = data.webBannerItems
          this.videoUrl = data.videoUrl
          if(window.location.origin == 'https://pip.itcast.cn'){
            this.platIsOpen = data.platIsOpen
          }    
          this.platformInfo = {
            platColor:data.platColor,
            platTitle:data.platTitle,
            platSubTitle: data.platSubTitle,
            platEnTitle:data.platEnTitle,
            playBgImg:data.playBgImg,
         }
         this.skillInfo = {
             title: data.skillTitle,
             subTitle: data.skillSubTitle,
             enTitle: data.skillEntitle
         }
          this.skillModular = data.webSkillModular ? data.webSkillModular : null
          this.platformData = data.platform && data.platform.length > 0 ? data.platform.filter((it) => it.subtitle) : []
          let objData ={}
          const objArr =[]
          this.platformData.forEach(element => {
              objData ={
                      ...element,
                  }
              if(element.subtitle==='FALSE'){
                  objData ={
                      ...element,
                      subtitle:'false'
                  }
                  
              }
              objArr.push(objData)
          });
          this.platformData=objArr
          this.modelData = data.modular
          this.programData = data.program[0]
          this.classInfo = {
              classTitle: data.classTitle,
              classEnTitle: data.classEnTitle
          }
          this.classData = data.classList
          this.teacherInfo = {
              teachModleTitle: data.teachModleTitle,
              TeachEnTitle: data.TeachEnTitle,
              teachBgColor: data.teachBgColor,
              teachBgImg: data.teachBgImg
          }
          this.teacherList = data.teacheres
          this.topImg = data.topImg.length > 0 ? data.topImg[0].url : ''
          this.butImg = data.botImg.length > 0 ? data.botImg[0].url : ''
          this.acttionInfo = {
              actionlabel: data.actionlabel,
              actionImg: data.actionImg
          }
        //   this.scrollHandle()
        });
    },
    scrollMoveHandle() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 显示马上学习导航
      let tag2 = document.querySelector("#scrollA");
      let tag3 = document.querySelector("#scrollB");
      let tagX = document.querySelector("#scrollX");
      let tag4 = document.querySelector("#scrollC");
      let tag41 = document.querySelector("#scrollC1");
      let tag5 = document.querySelector("#scrollD");
      const num = 650
      if (scrollTop >= tag2.offsetTop - num) {
        this.scrollAShow = true;
      }
      if (scrollTop >= tagX.offsetTop - num) {
        this.scrollXShow = true;
      }
      if (scrollTop >= tag2.offsetTop - 50) {
        this.scrollA1Show = true;
      }
      if (scrollTop >= tag3.offsetTop - num) {
        this.scrollBShow = true;
      }
      if (scrollTop >= tag4.offsetTop - num) {
        this.scrollCShow = true;
      }
      if (scrollTop >= tag41.offsetTop - num) {
        this.scrollC1Show = true;
      }
      if (scrollTop >= tag5.offsetTop - num) {
        this.scrollDShow = true;
      }
    },
    // 鼠标滑过展示二维码
    rwmHover(index) {
        this.showRwm = index
    },
    // 
    goDetailPage(url){
        if (url && /^http/.test(url)){
            //     window.open(url, '_black')
          this.goUrl = url
          this.$refs.RiskWarning.dialogFormV()
        }
    },
    // 点击体验弹窗
    openActionHandle(){
        this.showActionPop = true
    },
    // 解决方案切换
    checkHandle(ind){
        this.programState = ind
    },
    // 解决方案自动滚动
    scrollHandle(){
        if (this.programData){
            const num = this.programData.AboutImage.length-1;
            clearInterval(this.timer)
            this.timer = setInterval(() => {
                if (this.programState == num){
                    this.programState = 0;
                } else {
                    this.programState ++;
                }
            }, 3000)
        }
    },
    stopScroll(){
        clearInterval(this.timer)
    },
    setScroll(){
        this.scrollHandle()
    },
    closeTopImg(){
        window.localStorage.setItem('topImgSt','unShow')
        this.topImgSt = false
    },
    handleVideo() {
      this.$trackEvent("视频介绍", "点击", "前端学科");
      let obj = {
        url: this.videoUrl,
      };
      this.$refs.editMenu.dialogFormV(obj);
    }
  },
  beforeDestroy(){
      this.stopScroll()
      window.removeEventListener("scroll", this.scrollMoveHandle);
  }
};
</script>
<style lang="scss" scoped src="./index.scss"></style>>
